// extracted by mini-css-extract-plugin
export default {"dropdown-menu":"dropdown-menu__HDadx","dropdownLink":"dropdownLink__decOk","button":"button__b3Qqx","correct":"correct__ZdoTz","incorrect":"incorrect__e2Vlm"};